import NProgress from 'nprogress';

import accountRoutes from "@/app.account/routes";

import homeRoutes from "@/app.home/routes";
import aboutRoutes from "@/app.about/routes";
import contactRoutes from "@/app.contact/routes";
// import newsRoutes from '@/app.news/routes'
// import imageRoutes from '../app.image/routes'
// import sassRoutes from '../app.sass/routes'
// import templateRoutes from '../app.template/routes'
// import settingRoutes from '../app.setting/routes'

// import companyRoutes from '../manage.project/routes'
import userRoutes from '@/app.user/routes';
// import roleRoutes from '../manage.role/routes
import storeProductRoutes from "@/store.product/routes";
import storeCatalogsRoutes from "@/store.catalog/routes";
// import storeProviderRoutes from '../store.provider/routes'
import storeOrderRoutes from "@/store.order/routes";

const routes = []
  .concat(accountRoutes)
  .concat(homeRoutes)
  .concat(aboutRoutes)
  .concat(contactRoutes)
  // .concat(newsRoutes)
  // .concat(imageRoutes)
  // .concat(sassRoutes)
  // .concat(templateRoutes)
  // .concat(settingRoutes)

  // .concat(companyRoutes)
  .concat(userRoutes)
  // .concat(roleRoutes)

  .concat(storeProductRoutes)
  .concat(storeOrderRoutes)
  .concat(storeCatalogsRoutes)
  // .concat(storeProviderRoutes)

  .concat(contactRoutes)
  .concat({
    name: 'notFoundPage',
    path: '/404/page-not-found/page-not-found', meta: { title: 'Not Found', layout: '' }, component: {
        template:
        '<div class="grid-container">' +
            '<div class="grid-x grid-padding-x grid-padding-y">' +
                '<div class="cell">' +
                    '<h1>:(</h1>' +
                    '<h2>Not Found</h2>' +
                    '<p>The requested page was not found.</p>' +
                '</div>' +
            '</div>' +
        '</div>',
        mounted(){
            // $(this.$el).foundation();

            // $('.gml-app').addClass('gml-app-ready');
            // $('#gml-app-loader').fadeOut();
        }
    }
},
{
  name: '404',
  path: '*', redirect: '/404/page-not-found/page-not-found'
}
)
  ;

//Not found


import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

var vueRouter = new VueRouter({
  mode: "history",
  scrollBehavior(to) { //, from, savedPosition
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});


// This callback runs before every route change, including on page load.
vueRouter.beforeEach((to, from, next) => {
  //Update body class depending on URL slug For Style flexibility
  //document.body.className = to.fullPath.substring(to.fullPath.lastIndexOf('/') + 1);

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = 
  from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
          tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
  })
  // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag));

  next();
});

vueRouter.beforeResolve((to, from, next) => {
  //if (to.path && window.isInitialized){
    if (to.path){
      NProgress.start();
  }
  next();
});

vueRouter.afterEach((to/*, from*/)=>{
  NProgress.done();

  //Update body class depending on URL slug For Style flexibility
  document.body.className = to.fullPath.substring(to.fullPath.lastIndexOf('/') + 1);

  // var $offCanvas = $('[data-off-canvas]');
  // if ($offCanvas.hasClass('is-open')){
  //     $offCanvas.foundation('close');
  // }
});


Vue.use(vueRouter);

export default vueRouter;